import React from 'react';
import ReactDOM from 'react-dom/client';
import ErrorBoundary from 'components/ErrorBoundary';
import Maintenance from 'components/Maintenance';
import { ApolloClientProvider } from 'core/apollo';
import { configureDatadog } from 'core/datadog';
import App from './App';
import './fonts.css';
import './index.css';
import reportWebVitals from './reportWebVitals';

configureDatadog();

const root = ReactDOM.createRoot(
  document.getElementById('act-dashboard-brighte-root') as HTMLElement
);

root.render(
  <ErrorBoundary fallback={<Maintenance />}>
    <ApolloClientProvider>
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </ApolloClientProvider>
  </ErrorBoundary>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
